import script from "./GestaoMaskLaudos.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoMaskLaudos.vue?vue&type=script&setup=true&lang=js"

import "./GestaoMaskLaudos.vue?vue&type=style&index=0&id=6abd7dd8&lang=css"

const __exports__ = script;

export default __exports__